export const PLAYER_SPEED = 5.2;
export const PLAYER_SPRINT_SPEED = 8.2;
export const PLAYER_RADIUS = 0.48;
export const KICK_RANGE = 2.55;
/** Rear-centered kick sector in degrees. Includes both sides. */
export const KICK_ANGLE = 210;
export const KICK_COOLDOWN = 0.68;
export const KICK_IMPACT_TIME = 0.33;

export const MONSTER_ATTACK_RANGE = 2.35;
/** Full frontal mouth danger cone in degrees. */
export const MONSTER_ATTACK_ANGLE = 100;
export const MONSTER_SPEED = 1.35;
export const MONSTER_ROTATION_SPEED = 0.9;
export const MONSTER_DETECTION_RANGE = 10.5;
export const MONSTER_ATTACK_WINDUP = 0.78;
export const MONSTER_ATTACK_CONNECT_TIME = 0.38;
/** Gentle flocking values that keep several monsters from choosing one lane. */
export const MONSTER_SEPARATION_RADIUS = 2.35;
export const MONSTER_SEPARATION_STRENGTH = 0.58;
export const MONSTER_PURSUIT_SPREAD = 1.05;

export const DIFFICULTY_MULTIPLIER = 0.045;
export const GRID_CELL_SIZE = 1.5;
export const MAX_LEVELS = 10;

export const BALANCE = {
  PLAYER_SPEED,
  PLAYER_SPRINT_SPEED,
  PLAYER_RADIUS,
  KICK_RANGE,
  KICK_ANGLE,
  KICK_COOLDOWN,
  KICK_IMPACT_TIME,
  MONSTER_ATTACK_RANGE,
  MONSTER_ATTACK_ANGLE,
  MONSTER_SPEED,
  MONSTER_ROTATION_SPEED,
  MONSTER_DETECTION_RANGE,
  MONSTER_ATTACK_WINDUP,
  MONSTER_ATTACK_CONNECT_TIME,
  MONSTER_SEPARATION_RADIUS,
  MONSTER_SEPARATION_STRENGTH,
  MONSTER_PURSUIT_SPREAD,
  DIFFICULTY_MULTIPLIER,
} as const;

export type QualityPreset = 'LOW' | 'MEDIUM' | 'HIGH';

export function chooseInitialQuality(): QualityPreset {
  const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 4;
  const cores = navigator.hardwareConcurrency ?? 4;
  if (mobile || memory <= 4 || cores <= 4) return 'LOW';
  if (memory >= 8 && cores >= 8) return 'HIGH';
  return 'MEDIUM';
}
